import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ExtraPages.css';

const modules = [
  {
    name: 'Business Ideas & Validation',
    summary: 'Identify real customer pain points and test assumptions quickly.',
  },
  {
    name: 'Marketing & Sales',
    summary: 'Craft a message, choose channels, and build a simple sales flow.',
  },
  {
    name: 'Money Skills',
    summary: 'Understand cost, pricing, profit, and cash flow with practical examples.',
  },
  {
    name: 'Business Strategy',
    summary: 'Set priorities, evaluate trade-offs, and make smarter growth decisions.',
  },
  {
    name: 'Pitching & Storytelling',
    summary: 'Communicate your idea with clarity and structure that earns attention.',
  },
  {
    name: 'Product Basics',
    summary: 'Define MVP scope and improve your offer based on user feedback.',
  },
];

const ModulesPage = () => {
  return (
    <main className="extra-page-shell">
      <section className="extra-page-hero">
        <p className="extra-kicker">Learning Modules</p>
        <h1>Choose a path and build your entrepreneurship skill stack.</h1>
        <p>Each module is short, interactive, and paired with game-based practice.</p>
      </section>

      <section className="module-cards">
        {modules.map((moduleItem) => (
          <article key={moduleItem.name} className="module-card">
            <h2>{moduleItem.name}</h2>
            <p>{moduleItem.summary}</p>
          </article>
        ))}
      </section>

      <div className="extra-actions">
        <Link to="/games" className="extra-btn solid">Practice With Games</Link>
        <Link to="/" className="extra-btn light">Back Home</Link>
      </div>
    </main>
  );
};

export default ModulesPage;
